'use client';
import { createContext, ReactNode, useContext } from 'react';
import { EnvConfig } from '../types/config';

export const getConfig = (
  publicRuntimeEnv: Record<string, string>,
): EnvConfig => ({
  pgstURL: publicRuntimeEnv.POSTGREST_URL || 'http://localhost:5002',
  storageURL: publicRuntimeEnv.STORAGE_URL || 'http://localhost:9000',
});

// Use a distinct name for the context variable
const EnvConfigReactContext = createContext<EnvConfig>(getConfig({}));

// Provider props
interface EnvConfigProviderProps {
  publicRuntimeEnv: Record<string, string>;
  children: ReactNode;
}

// Provider component
export function EnvConfigProvider({
  publicRuntimeEnv,
  children,
}: EnvConfigProviderProps) {
  const config = getConfig(publicRuntimeEnv);
  return (
    <EnvConfigReactContext.Provider value={config}>
      {children}
    </EnvConfigReactContext.Provider>
  );
}

// Custom hook to consume the context safely
export const useConfig = (): EnvConfig => {
  const context = useContext(EnvConfigReactContext);
  if (!context) {
    throw new Error('useConfig must be used within an EnvConfigProvider');
  }
  return context;
};
